import { TEST_IDS } from '@/lib/testIds'
import { cn } from '@/lib/utils'

export function AppVersion({ includeCommit = false, className }: { includeCommit?: boolean; className?: string }) {
  return (
    <span
      title={`Commit ${__APP_COMMIT__}`}
      data-testid={TEST_IDS.appVersion}
      className={cn('tabular-nums', className)}
    >
      v{__APP_VERSION__}{includeCommit ? ` · ${__APP_COMMIT__.slice(0, 7)}` : null}
    </span>
  )
}
